<div id="translist-form" class="flex flex-col gap-2">
  <barcode-scanner-search-field
    (onSearch)="searchFilter.set($event)"
    (onCode)="codeScanned($event)"
  ></barcode-scanner-search-field>

  <div id="transaction-list" class="flex flex-col gap-2 rounded-sm bg-neutral-800">
    @if (loadingTransactions()) {
      <p-skeleton height="2.5rem" />
      <p-skeleton height="2.5rem" />
      <p-skeleton height="2.5rem" />
    } @else {
      @for (trans of filteredTransactions(); track trans) {
        <inv-transaction-list-item
          [transaction]="trans"
          (changed)="loadTransactions()"
          (view)="openTransaction(trans)"
        ></inv-transaction-list-item>
      } @empty {
        <empty-state
          [icon]="'search_off'"
          [title]="'internal.inventory.transactionList.empty.title' | translate"
          [subtitle]="'internal.inventory.transactionList.empty.subtitle' | translate"
          [showButton]="true"
          [buttonText]="'internal.inventory.transactionList.empty.button' | translate"
          (buttonClick)="resetScannerField()"
        >
        </empty-state>
      }
    }
  </div>
</div>

<div class="flex justify-end gap-2 mt-4">
  <p-button [label]="'general.close' | translate" severity="secondary" (onClick)="closeDialog()" />
</div>
